import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputMoney, InputSelect, InputSwitch, InputPicklist, InputPercentage } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './amounttype-model';  //editable..
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class AmounttypeView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseView history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                }
                <InputSelect name='calc' label='Calculation' value={this.state.datarow.calc} options={Model.optionCalc} error={this.state.errors?.calc} readOnly/>
                {Model.asPercentage(this.state.datarow.calc)?
                <InputPercentage name='value' label='Percentage' value={this.state.datarow.value} readOnly/>
                : <InputMoney name='value' label='Value' value={this.state.datarow.value} readOnly/>
                } 
                <InputPicklist name='journalgroup' label='Journal Group' value={this.state.datarow.journalgroup} caption={this.state.datarow.journalgroupCaption} readOnly/>
  
            </BaseView>
        );
    }
}